import { render, staticRenderFns } from "./CashSettlementsStatementsDetailsTable.vue?vue&type=template&id=5ccff6e6&scoped=true&"
import script from "./CashSettlementsStatementsDetailsTable.vue?vue&type=script&lang=js&"
export * from "./CashSettlementsStatementsDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./CashSettlementsStatementsDetailsTable.vue?vue&type=style&index=0&id=5ccff6e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccff6e6",
  null
  
)

export default component.exports